import { Store } from "pullstate";


export const RedirectStore = new Store({
   redirectPlan:null
  });